
// Only used to make the frontend user-friendly. The backend has its own protection. 

const protectedPaths = ['Recent', 'Patients', 'Downloads', 'Documents']; 

export default protectedPaths; 

